export const RF_TRANSMITTER_TYPE_OPTIONS = {
    omnidirectional: 'Omnidirectional',
    beam: 'Beam',
    antFile: 'ANT File',
};
